export default "/react/logoSplitTest-d0d819f6.png";